import { Component, OnInit } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
    selector: "app-hawlfraint",
    templateUrl: "./hawlfraint.component.html",
    styleUrl: "./hawlfraint.component.scss",
    imports: [FaIconComponent]
})
export class HawlfraintComponent implements OnInit {
  
  constructor() {}

  ngOnInit(): void {}

  nolLogo(): string {
    return "assets/lluniau/navbar_cg.png";
  }

  nolLogoDatblygu(): string {
    return "assets/lluniau/logo_datblygu.png";
  }
}
